<template>
  <div class="view-home">
    <div class="container">
      <div class="loader-container">
        <Loader/>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Loader from "@/components/Loader.vue";

export default {
  name: 'Poll',
  components: {Loader},
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {

    if(localStorage.getItem('user')) {
      const user = JSON.parse(localStorage.getItem('user'))

      this.$http.post(window.API_ROOT + '/api/user/polled-by-iin', {
        iin: user.iin,
        polled: 1
      })
          .then(res => {
            console.log(res)
          })
          .catch(err => {
            console.warn(err)
          })
          .finally(() => {
            this.$router.push('/cabinet');
          });
    } else {
      this.$router.push('/cabinet');
    }
  }
}
</script>
<style>
.loader-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
